<ng-container *ngIf="(getActivePublication$ | async) as publication">
  <!-- Cint       -->
  <div appFlex="nogrow" *ngIf="publication.datas.generalInfo.contributors.cint" appFlexLayout="column" class="mat-elevation-z2 p-8 w-100-p">

    <span *ngIf="displayTitle" class="mat-headline-5">Cint</span>

    <div class="message-box warning" *ngIf="!publication.uxInteractions.review.cintCommunity.exist">
      {{'La communauté pour Cint n\'existe pas ?'|translate}}...
    </div>

    <div *ngIf="!publication.datas.generalInfo.contributors.cintTokens?.complete" class="message-box error m-4">
      {{'Cint token complete manquant !' | translate}}
    </div>
    <div *ngIf="!publication.datas.generalInfo.contributors.cintTokens?.screenout" class="message-box error m-4">
      {{'Cint token screenout manquant !' | translate}}
    </div>

    <ng-container *ngIf="publication.uxInteractions.review.cintCommunity.exist">

      <ng-container *ngIf="!publication.datas.generalInfo.hasV2Survey">
        <app-url-placeholder [url]="getUrlLink(publication.uxInteractions.review.cintCommunity.projectSlug, publication.datas.generalInfo.contributors.cintCommunityId, true)"></app-url-placeholder>
        <pre *ngIf="publication.uxInteractions.debugMode">{{getUrlLink(publication.uxInteractions.review.cintCommunity.projectSlug, publication.datas.generalInfo.contributors.cintCommunityId, true)}}</pre>
      </ng-container>

      <ng-container *ngIf="publication.datas.generalInfo.hasV2Survey">
        <app-url-placeholder [url]="getUrlLink(publication.uxInteractions.review.cintCommunity.projectSlug, publication.datas.generalInfo.contributors.cintCommunityId, true, true)"></app-url-placeholder>
        <pre *ngIf="publication.uxInteractions.debugMode">{{getUrlLink(publication.uxInteractions.review.cintCommunity.projectSlug, publication.datas.generalInfo.contributors.cintCommunityId, true, true)}}</pre>
      </ng-container>

    </ng-container>


  </div>
</ng-container>
